import { ValidationSchema } from 'validation-schema-library';

const familyInfoValidationSchema: ValidationSchema = {
  extendedInformation: {
    type: 'object',
    properties: {
      other: {
        type: 'array',
        maxSize: 10,
        forEach: {
          type: 'object',
          _divisible: false,
          properties: {
            dateOfBirth: {
              type: {
                value: 'date',
                message: 'Please, enter a valid date',
              },
              required: true,
              maxDate: {
                value: '$NOW',
                message: 'Must be in the past',
              },
            },
            relation: {
              type: 'string',
              required: true,
              maxSize: 24,
            },
            name: {
              type: 'object',
              _divisible: false,
              properties: {
                firstName: {
                  type: 'string',
                  required: true,
                  maxSize: 64,
                },
                lastName: {
                  type: 'string',
                  required: true,
                  maxSize: 64,
                },
                middleName: {
                  type: 'string',
                  maxSize: 64,
                },
              },
            },
          },
        },
      },
      children: {
        type: 'array',
        maxSize: 10,
        forEach: {
          type: 'object',
          _divisible: false,
          properties: {
            dateOfBirth: {
              type: {
                value: 'date',
                message: 'Please, enter a valid date',
              },
              required: true,
              maxDate: {
                value: '$NOW',
                message: 'Must be in the past',
              },
            },
            relation: {
              type: 'string',
              required: true,
              maxSize: 24,
            },
            name: {
              type: 'object',
              _divisible: false,
              properties: {
                firstName: {
                  type: 'string',
                  required: true,
                  maxSize: 64,
                },
                lastName: {
                  type: 'string',
                  required: true,
                  maxSize: 64,
                },
                middleName: {
                  type: 'string',
                  maxSize: 64,
                },
              },
            },
          },
        },
      },
    },
  },
};

const getFamilyInfoValidationSchema = () => Promise.resolve(familyInfoValidationSchema);

export default getFamilyInfoValidationSchema;
